/** @jsxImportSource @emotion/react */
import { getDuration } from '~/services/layout/layout';
import type { FeedEntry } from '~/services/layout/index.ts';
import {
  getCellBreakpointValues,
  getCellVisibillityClasses,
  getCellVisibilityStatus,
} from './power-cell-getters';
import { type SerializedStyles } from '@emotion/react';

export function RuntimeV2({
  entry,
  styles,
  dynamicColors,
}: {
  entry: FeedEntry;
  styles: any;
  dynamicColors: {
    background: SerializedStyles;
    font: SerializedStyles;
  };
}): JSX.Element {
  const duration: string | undefined = getDuration(entry);
  const cellBreakpointValues = getCellBreakpointValues({
    config: styles,
    key: 'runtime_switch',
  });

  if (!duration || !getCellVisibilityStatus(cellBreakpointValues)) return <></>;

  return (
    <div
      className={getCellVisibillityClasses(
        cellBreakpointValues,
        'absolute bottom-0 right-0 z-[4]'
      )}
    >
      <div
        className="mb-runtime-b ml-runtime-l mr-runtime-r mt-runtime-t rounded-runtime-radius bg-runtime pb-runtime-b pl-runtime-l pr-runtime-r pt-runtime-t"
        css={dynamicColors?.background}
      >
        <p
          className="font-runtime-font-family text-runtime-font-size text-runtime-color"
          css={dynamicColors?.font}
        >
          <span className="leading-runtime-line-height tracking-runtime-letter-spacing">
            {duration}
          </span>
        </p>
      </div>
    </div>
  );
}
